// extracted by mini-css-extract-plugin
export default {"cls1":"IADuVX35Nexbc2Kue4LR","cls2":"yAlM7Smv0M6d9hZKToKr IADuVX35Nexbc2Kue4LR"};